// extracted by mini-css-extract-plugin
module.exports = {"DateWrapper":"Date_DateWrapper__Eg4G0"};